import { Grid } from "@mui/material";
import React from "react";
import { TaskDataRowDataType } from "ui/Scripts/source/models/enums";
import { ITaskTypeCol, TaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { FormInteger } from "source/components/framework/FormInteger";
import { FormDecimal } from "source/components/framework/FormDecimal";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";

interface IFormDesignerComponentPropertiesMinMaxProps {
    formFieldMargin: string;
    taskTypeCol?: ITaskTypeCol;
    onTaskTypePropUpdate?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

export const FormDesignerComponentPropertiesMinMax = (
    props: IFormDesignerComponentPropertiesMinMaxProps
) => {
    if (!(props.taskTypeCol?.dataType === TaskDataRowDataType.Number || props.taskTypeCol?.dataType === TaskDataRowDataType.Integer) || TaskTypeCol.isCalculatedField(props.taskTypeCol)) return null;
    return (
        <>
            <Grid item sm={6}>
                <FormField title={Translations.FormMinimumValue} margin={props.formFieldMargin}>
                    {(props.taskTypeCol?.dataType === TaskDataRowDataType.Number
                        ? <FormDecimal
                            decimals={props.taskTypeCol?.decimals ?? 0}
                            min={-99999999}
                            max={props.taskTypeCol?.maximum}
                            maxLength={10}
                            value={props.taskTypeCol?.minimum}
                            required={false}
                            onChange={(value) => {
                                props.onTaskTypePropUpdate([{
                                    field: props.taskTypeCol?.field,
                                    name: "minimum",
                                    value
                                }]);
                            }}
                        />
                        : <FormInteger
                            min={-99999999}
                            max={props.taskTypeCol?.maximum}
                            maxLength={10}
                            value={props.taskTypeCol?.minimum}
                            required={false}
                            onChange={(value) => {
                                props.onTaskTypePropUpdate([{
                                    field: props.taskTypeCol?.field,
                                    name: "minimum",
                                    value
                                }]);
                            }}
                        />
                    )}
                </FormField>
            </Grid>
            <Grid item sm={6}>
                <FormField title={Translations.FormMaximumValue} margin={props.formFieldMargin}>
                    {(props.taskTypeCol?.dataType === TaskDataRowDataType.Number
                        ? <FormDecimal
                            decimals={props.taskTypeCol?.decimals ?? 0}
                            min={props.taskTypeCol?.minimum}
                            maxLength={10}
                            value={props.taskTypeCol?.maximum}
                            required={false}
                            onChange={(value) => {
                                props.onTaskTypePropUpdate([{
                                    field: props.taskTypeCol?.field,
                                    name: "maximum",
                                    value
                                }]);
                            }}
                        />
                        : <FormInteger
                            min={props.taskTypeCol?.minimum}
                            maxLength={10}
                            value={props.taskTypeCol?.maximum}
                            required={false}
                            onChange={(value) => {
                                props.onTaskTypePropUpdate([{
                                    field: props.taskTypeCol?.field,
                                    name: "maximum",
                                    value
                                }]);
                            }}
                        />
                    )}
                </FormField>
            </Grid>
        </>
    );
};
